import { render, staticRenderFns } from "./CompanyPass.vue?vue&type=template&id=331e7193"
import script from "./CompanyPass.vue?vue&type=script&lang=js"
export * from "./CompanyPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports